import React from 'react';
import Button from '../core/Button';
import Modal from './Modal';

export interface Props {
  open: boolean;
  valueStatus: (e: any) => void;
  deleteState: (e: any) => void;
  onClose?: () => void;
  onYes?: () => void;
}

export default function DeletePropertyModal(props: Props) {
  return (
    <Modal
      title={'Va a eliminar su propiedad de BIMMO'}
      open={props.open}
      onClose={props.onClose}
    >
      <h4>
        Para completar la eliminación, díganos por que desea eliminar este
        anuncio:
      </h4>
      <div>
        <input
          style={{ marginTop: 20, marginRight: 5 }}
          type="radio"
          id="vendida"
          name="reason"
          onClick={() => {
            props.valueStatus('vendida');
            props.deleteState('Vendida por BIMMO');
          }}
        />
        <label htmlFor="vendida">Lo he vendido a través de BIMMO</label>
      </div>
      <div>
        <input
          style={{ marginTop: 20, marginRight: 5 }}
          type="radio"
          id="vendidaotro"
          name="reason"
          onClick={() => {
            props.valueStatus('inactiva');
            props.deleteState('Vendida por otro servicio');
          }}
        />
        <label htmlFor="vendidaotro">
          Lo he vendido a través de otro servicio
        </label>
      </div>
      <div>
        <input
          style={{ marginTop: 20, marginRight: 5 }}
          type="radio"
          id="noventa"
          name="reason"
          onClick={() => {
            props.valueStatus('inactiva');
            props.deleteState('He dicidido no venderla');
          }}
        />
        <label htmlFor="noventa">He dicidido no venderla</label>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}>
        <input
          style={{ marginRight: 5 }}
          type="radio"
          id="otro"
          name="reason"
          onClick={() => {
            props.valueStatus('inactiva');
          }}
        />
        <label style={{ marginRight: 5 }} htmlFor="otro">
          Otro
        </label>
        <input
          style={{ width: '100%' }}
          type="text"
          onInput={(e: any) => {
            props.valueStatus('inactiva');
            props.deleteState(e.target.value);
          }}
        />
      </div>

      <div
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}
      >
        <Button
          style={{ minWidth: 80 }}
          label="Eliminar Anuncio"
          onClick={props.onYes}
        />
        <Button
          style={{ minWidth: 80, marginLeft: 10 }}
          label="Cancelar"
          onClick={props.onClose}
        />
      </div>
    </Modal>
  );
}
